// Mirror of Telephony/Models/TelephonyCommandNames.cs - the locked Phase-1 wire names.
// "the names the cloud, the device, and the UI all must agree on. Do not invent names elsewhere."
// Legacy PacketDataType each derives from is kept in a comment for traceability.

export const TelephonyCommandNames = {
  // --- Call control ---
  MakeCall: 'tel_make_call',                 // 312
  Redial: 'tel_redial',                      // 340
  SendDtmf: 'tel_send_dtmf',                 // 313
  Hangup: 'tel_hangup',                      // 317 / 338
  Answer: 'tel_answer',                      // 323
  Reject: 'tel_reject',                      // 324
  Redirect: 'tel_redirect',                  // 316
  BlindTransfer: 'tel_blind_transfer',       // 318
  AttendedTransfer: 'tel_attended_transfer', // 319
  PhoneTransfer: 'tel_phone_transfer',       // 343
  Hold: 'tel_hold',                          // 320 (ARI)
  Unhold: 'tel_unhold',                      // 321 (ARI)
  Park: 'tel_park',                          // 322
  Unpark: 'tel_unpark',                      // 342
  Pickup: 'tel_pickup',                      // 329
  Mute: 'tel_mute',                          // 307 (bench-conditional)
  Unmute: 'tel_unmute',                      // 308 (bench-conditional)
  // --- Agent / queue ---
  QueueLogin: 'tel_queue_login',             // 314
  QueueLogout: 'tel_queue_logout',           // 314
  QueuePause: 'tel_queue_pause',             // 315
  QueueUnpause: 'tel_queue_unpause',         // 315
  // --- Supervisor ---
  Monitor: 'tel_monitor',                    // 326 (ARI snoop)
  Whisper: 'tel_whisper',                    // 328
  Barge: 'tel_barge',                        // 327
  // --- Recording ---
  RecordStart: 'tel_record_start',           // 341
  RecordStop: 'tel_record_stop',             // 341
  // --- Extension config ---
  SetDnd: 'tel_set_dnd',                     // 309 / 310
  SetCallForward: 'tel_set_call_forward',    // 332 / 333 / 334
  GetCallForward: 'tel_get_call_forward',    // 335
  // --- Phone poke ---
  PhoneKeyPress: 'tel_phone_key_press',      // 339
  // --- Voicemail ---
  VoicemailList: 'tel_vm_list',              // 306
  VoicemailDelete: 'tel_vm_delete',          // 346
  VoicemailMarkRead: 'tel_vm_mark_read',     // 348
  VoicemailForward: 'tel_vm_forward'         // 345
} as const

export type TelephonyCommandName =
  (typeof TelephonyCommandNames)[keyof typeof TelephonyCommandNames]

// Routing sets mirrored from the C# convenience sets (reference / client-side hints only).
export const AmiCommands: ReadonlySet<TelephonyCommandName> = new Set([
  TelephonyCommandNames.MakeCall, TelephonyCommandNames.Redial, TelephonyCommandNames.SendDtmf,
  TelephonyCommandNames.Hangup, TelephonyCommandNames.Answer, TelephonyCommandNames.Reject,
  TelephonyCommandNames.Redirect, TelephonyCommandNames.BlindTransfer, TelephonyCommandNames.AttendedTransfer,
  TelephonyCommandNames.Park, TelephonyCommandNames.Unpark, TelephonyCommandNames.Pickup,
  TelephonyCommandNames.QueueLogin, TelephonyCommandNames.QueueLogout, TelephonyCommandNames.QueuePause,
  TelephonyCommandNames.QueueUnpause, TelephonyCommandNames.RecordStart, TelephonyCommandNames.RecordStop,
  TelephonyCommandNames.Mute, TelephonyCommandNames.Unmute, TelephonyCommandNames.VoicemailList,
  TelephonyCommandNames.VoicemailDelete, TelephonyCommandNames.VoicemailMarkRead, TelephonyCommandNames.VoicemailForward
])

export const AriCommands: ReadonlySet<TelephonyCommandName> = new Set([
  TelephonyCommandNames.Hold, TelephonyCommandNames.Unhold,
  TelephonyCommandNames.Monitor, TelephonyCommandNames.Whisper, TelephonyCommandNames.Barge
])

export const PhoneProfileCommands: ReadonlySet<TelephonyCommandName> = new Set([
  TelephonyCommandNames.PhoneKeyPress, TelephonyCommandNames.PhoneTransfer, TelephonyCommandNames.Answer
])

export const ConfigCommands: ReadonlySet<TelephonyCommandName> = new Set([
  TelephonyCommandNames.SetDnd, TelephonyCommandNames.SetCallForward, TelephonyCommandNames.GetCallForward
])
